import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { SectorsPage } from './pages/SectorsPage';
import { ContactPage } from './pages/ContactPage';
import { PreQualification } from './pages/PreQualification';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="about" element={<AboutPage data-id="element-7" />} data-id="element-6" />
          <Route path="services" element={<ServicesPage data-id="element-9" />} data-id="element-8" />
          <Route path="sectors" element={<SectorsPage data-id="element-11" />} data-id="element-10" />
          <Route path="contact" element={<ContactPage data-id="element-13" />} data-id="element-12" />
          <Route path="pre-qualification" element={<PreQualification data-id="element-15" />} data-id="element-14" />
        </Route>
      </Routes>
    </BrowserRouter>;
}